// @scripts
import { IEnrollment } from '../utils/types';
import { config } from '../core/config';
import BaseService from './base-service';

class StrategiesService extends BaseService {
  async getSiteEnrollment(siteId: number): Promise<IEnrollment[]> {
    return this.get(['siteEnrollments', siteId]);
  }
}

export default new StrategiesService(config.services.strategies);
